export const ActionTypes = {
  ADD_REPLAY_TRACK_TO_PLAYLIST: 'GLOBAL_ADD_REPLAY_TRACK_TO_PLAYLIST',
  ADD_TRACK_FEEDBACK: 'ADD_TRACK_FEEDBACK',
  ADVANCE_PLAYLIST: 'GLOBAL_ADVANCE_PLAYLIST',
  AUTO_LOGIN: 'AUTO_LOGIN',
  CHANGE_INTERACTIVE_RADIO_MODE: 'CHANGE_INTERACTIVE_RADIO_MODE',
  CHECK_IS_PLAYABLE_SOURCE: 'GLOBAL_CHECK_IS_PLAYABLE_SOURCE',
  CLOSE_REWARDS_COACHMARK: 'GLOBAL_CLOSE_REWARDS_COACHMARK',
  CLOSE_SEARCH: 'CLOSE_SEARCH',
  COMMUNITY_LOGOUT: 'COMMUNITY_LOGOUT',
  HANDLE_PREMIUM_ACCESS: 'HANDLE_PREMIUM_ACCESS',
  INITIATE_PREMIUM_ACCESS: 'INITIATE_PREMIUM_ACCESS',
  INSERT_NEW_SIM_STREAM_VIOLATION: 'GLOBAL_INSERT_NEW_SIM_STREAM_VIOLATION',
  LINK_CLICKED: 'LINK_CLICKED',
  COMPONENT_SCROLLED: 'COMPONENT_SCROLLED',
  LOAD_STATIONS: 'GLOBAL_LOAD_STATIONS',
  LOG_API_ERROR_SHOWN: 'LOG_API_ERROR_SHOWN',
  LOG_EVENTS: 'GLOBAL_LOG_EVENTS',
  LOG_WEB_VIEW_MODE_EVENT: 'LOG_WEB_VIEW_MODE_EVENT',
  LOGIN_LISTENER: 'LOGIN_LISTENER',
  NAVIGATE_TO_COMMUNITY: 'NAVIGATE_TO_COMMUNITY',
  OPEN_ERROR_TOAST: 'OPEN_ERROR_TOAST',
  OPEN_SEARCH: 'OPEN_SEARCH',
  PAGE_RENDERED: 'PAGE_RENDERED',
  PAUSE_TRACK: 'GLOBAL_PAUSE_TRACK',
  PLAY_RESUME_SOURCE: 'GLOBAL_PLAY_RESUME_SOURCE',
  PLAY_REWARDS_AD: 'GLOBAL_PLAY_REWARDS_AD',
  PLAY_TRACK_FROM_STATION: 'GLOBAL_PLAY_TRACK_FROM_STATION',
  PROMPT_STREAM_VIOLATION: 'GLOBAL_PROMPT_STREAM_VIOLATION',
  REMOVE_TRACK_FEEDBACK: 'REMOVE_TRACK_FEEDBACK',
  REPLAY_TRACK: 'GLOBAL_REPLAY_TRACK',
  RESET_PASSWORD_AND_REAUTH: 'RESET_PASSWORD_AND_REAUTH',
  SCRUB_TRACK: 'SCRUB_TRACK',
  SET_CURRENT_TRACK_IN_PLAYLIST: 'GLOBAL_SET_CURRENT_TRACK_IN_PLAYLIST',
  SET_SOURCE_REPEAT_MODE: 'SET_SOURCE_REPEAT_MODE',
  SET_SOURCE_SHUFFLE_MODE: 'SET_SOURCE_SHUFFLE_MODE',
  SIGN_OUT: 'SIGN_OUT',
  SIGN_UP: 'SIGN_UP',
  SKIP_TRACK_BACK: 'GLOBAL_SKIP_TRACK_BACK',
  SKIP_TRACK_FORWARD: 'GLOBAL_SKIP_TRACK',
  SKIP_TRACK_FORWARD_CANCEL: 'SKIP_TRACK_FORWARD_CANCEL',
  SKIP_AUDIO_AD: 'SKIP_AUDIO_AD',
  SKIP_AD: 'SKIP_AD',
  START_NEXT_NON_SHUFFLE_STATION: 'GLOBAL_START_NEXT_NON_SHUFFLE_STATION',
  START_STATION: 'GLOBAL_START_STATION',
  START_VALUE_EXCHANGE: 'GLOBAL_START_VALUE_EXCHANGE',
  UPDATE_STATION: 'GLOBAL_UPDATE_STATION',
  UPGRADE: 'UPGRADE',
  GENERATE_DEEP_LINK: 'GENERATE_DEEP_LINK',
};
